import React from 'react';
import SimpleModal from '@teetsh/app/src/components/SimpleModal';
import { TrashIcon as Trash } from '@heroicons/react/24/outline';
import { useDeleteLivretEleve } from '@teetsh/app/src/containers/Livrets/queries/useDeleteLivretEleve';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  eleveName: string;
  livretEvalId: string;
  livretEleveId: string;
}

export function DeleteLivretEleveWarningModal(props: Props) {
  const { eleveName, onClose, isOpen, livretEleveId, livretEvalId } = props;
  const { t } = useTranslation(['carnet']);
  const deleteLivret = useDeleteLivretEleve({ livretEvalId });
  return (
    <SimpleModal
      isOpen={isOpen}
      title={t('carnet:livret.deleteLivretOfX', { eleveName })}
      buttonIcon={Trash}
      validateTitle={t('carnet:livret.yesDeleteThisLivret')}
      validateAction={() => deleteLivret(livretEleveId).then(onClose)}
      closeModalFct={() => onClose()}
    />
  );
}
